import React from 'react'

const OwnerMonthlyTimesheetOverview = ({timesheets, teachers, students, invoices}) => {
    const [isOpen, setIsOpen] = React.useState(false)
    const [teacherCancellations, setTeacherCancellations] = React.useState(0)
    const [studentCancellations, setStudentCancellations] = React.useState(0)
    const [chargedCancellations, setChargedCancellations] = React.useState(0)
    const [studentRevenueLoss, setStudentRevenueLoss] = React.useState(0)
    const [teacherRevenueLoss, setTeacherRevenueLoss] = React.useState(0)
    const [totalToChargeMMA, setTotalToChargeMMA] = React.useState(0)
    const [totalToChargeLSMA, setTotalToChargeLSMA] = React.useState(0)
    const [totalToChargeTMA, setTotalToChargeTMA] = React.useState(0)
    const [totalToChargeMOR, setTotalToChargeMOR] = React.useState(0)
    const [totalToChargePSMA, setTotalToChargePSMA] = React.useState(0)
    const [totalToChargeTEM, setTotalToChargeTEM] = React.useState(0)
    const [totalPayoutMMA, setTotalPayoutMMA] = React.useState(0)
    const [totalPayoutLSMA, setTotalPayoutLSMA] = React.useState(0)
    const [totalPayoutTMA, setTotalPayoutTMA] = React.useState(0)
    const [totalPayoutMOR, setTotalPayoutMOR] = React.useState(0)
    const [totalPayoutPSMA, setTotalPayoutPSMA] = React.useState(0)
    const [totalPayoutTEM, setTotalPayoutTEM] = React.useState(0)
    const [briPay, setBriPay] = React.useState(0)
    const [courtneyPay, setCourtneyPay] = React.useState(0)
    const [totalLessonsGiven, setTotalLessonsGiven] = React.useState(0)
    const [totalHoursOfLessonsGiven, setTotalHoursOfLessonsGiven] = React.useState(0)
    const [averageNumberOfLessonsTaught, setAverageNumberOfLessonsTaught] = React.useState(0)
    const [studentsTaught, setStudentsTaught] = React.useState(0)
    const [averageLessonHourlyCost, setAverageLessonHourlyCost] = React.useState(0)
    const [averageTeacherPay, setAverageTeacherPay] = React.useState(0)
    const schoolList = ['mma', 'lsma', 'tma', 'mor', 'psma', 'tem']
    const currencyFormatter = React.useMemo(() => new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
    }), [])

    React.useEffect(() => {
        if(timesheets.length > 0) {
            generateLossDueToCancellations()
            generateTotalLessonsGiven()
            generateAverageLessonsPerMonth()
        }
        if(students.length > 0 && teachers.length > 0 && invoices.length > 0) {
            generateTotalPayout()
        }
    }, [timesheets])

    React.useEffect(() => {
        if(students.length > 0 && teachers.length > 0 && invoices.length > 0) {
            generateTotalPayout()
            generateTotalBillingAmount()
            generateAverageLessonCost()
            generateAverageTeacherPayRate()
        }
    }, [invoices])

    React.useEffect(() => {
        if(students.length > 0 && teachers.length > 0) {
            generateTotalPayout()
            generateTotalBillingAmount()
        }
    }, [students, teachers])

    const generateLossDueToCancellations = () => {
        let first = 0;
        let second = 0;
        let third = 0;
        let firstLoss = 0;
        let secondLoss = 0;
        for(let i = 0; i < timesheets.length; i++) {
            for(let j = 0; j < timesheets[i].families.length; j++) {
                for(let k = 0; k < timesheets[i].families[j].cancellations.length; k++) {
                    if(timesheets[i].families[j].cancellations[k].cancellor === 'student') {
                        let theStudentsName = timesheets[i].families[j].cancellations[k].student
                        first++
                        for(let l = 0; l < timesheets[i].families[j].listOfFamilyStudents.length; l++) {
                            if(timesheets[i].families[j].listOfFamilyStudents[l].studentName === theStudentsName) {
                                //ADDING AN IF STATEMENT BECAUSE I HAVE ADDED A NEW WAY TO STORE STUDENT'S LESSONS RATES, BUT I STILL WANT TO ACCESS OLD DATA
                                if(!timesheets[i].families[j].listOfFamilyStudents[l].allRates) {
                                    firstLoss = firstLoss + Number(timesheets[i].families[j].listOfFamilyStudents[l].lessonRate)
                                } else {
                                    let lengthNumber = timesheets[i].families[j].listOfFamilyStudents[l].lessonLength
                                    firstLoss = firstLoss + Number(timesheets[i].families[j].listOfFamilyStudents[l].allRates[lengthNumber])
                                }
                            }
                        }
                    } else if (timesheets[i].families[j].cancellations[k].cancellor === 'teacher') {
                        let theStudentsName = timesheets[i].families[j].cancellations[k].student
                        second++
                        for(let l = 0; l < timesheets[i].families[j].listOfFamilyStudents.length; l++) {
                            if(timesheets[i].families[j].listOfFamilyStudents[l].studentName === theStudentsName) {
                                //ADDING AN IF STATEMENT BECAUSE I HAVE ADDED A NEW WAY TO STORE STUDENT'S LESSONS RATES, BUT I STILL WANT TO ACCESS OLD DATA
                                if(!timesheets[i].families[j].listOfFamilyStudents[l].allRates) {
                                    secondLoss = secondLoss + Number(timesheets[i].families[j].listOfFamilyStudents[l].lessonRate)
                                } else {
                                    let anotherLengthNumber = timesheets[i].families[j].listOfFamilyStudents[l].lessonLength
                                    secondLoss = secondLoss + Number(timesheets[i].families[j].listOfFamilyStudents[l].allRates[anotherLengthNumber])
                                }
                            }
                        }
                    } else if (timesheets[i].families[j].cancellations[k].cancellor === 'student less than 24hrs') {
                        third++
                    }
                }
            }
        }
        setStudentCancellations(first)
        setTeacherCancellations(second)
        setChargedCancellations(third)
        setStudentRevenueLoss(firstLoss)
        setTeacherRevenueLoss(secondLoss)
    }
    const generateAverageLessonCost = () => {
        let totalRevenue = 0
        let totalHoursTaught = 0
        for(let i = 0; i < invoices.length; i++) {
            let currentInvoice = invoices[i]
            for(let i = 0; i < currentInvoice.lessonsToBeBilled.length; i++) {
                let intLength = parseInt(currentInvoice.lessonsToBeBilled[i].lessonLength)
                let lessLength = intLength.toString()
                //console.log(lessLength)
                if(lessLength === '30') {
                    if(currentInvoice.lessonsToBeBilled[i].studentAllRates) {
                        totalRevenue = totalRevenue + currentInvoice.lessonsToBeBilled[i].studentAllRates[lessLength]
                        totalHoursTaught = totalHoursTaught + 0.5
                    }
                } else if(lessLength === '45') {
                    if(currentInvoice.lessonsToBeBilled[i].studentAllRates) {
                        totalRevenue = totalRevenue + currentInvoice.lessonsToBeBilled[i].studentAllRates[lessLength]
                        totalHoursTaught = totalHoursTaught + 0.75
                    }
                } else if(lessLength === '60') {
                    if(currentInvoice.lessonsToBeBilled[i].studentAllRates) {
                        totalRevenue = totalRevenue + currentInvoice.lessonsToBeBilled[i].studentAllRates[lessLength]
                        totalHoursTaught = totalHoursTaught + 1
                    }
                } else if(lessLength === '15') {
                    if(currentInvoice.lessonsToBeBilled[i].studentAllRates) {
                        totalRevenue = totalRevenue + currentInvoice.lessonsToBeBilled[i].studentAllRates[lessLength]
                        totalHoursTaught = totalHoursTaught + 0.25
                    }
                }
            }
        }
        setAverageLessonHourlyCost(Math.round((totalRevenue/totalHoursTaught) * 100) / 100)
    }

    const generateAverageTeacherPayRate = () => {
        let totalPay = parseInt(totalPayoutMMA + totalPayoutLSMA + totalPayoutTMA + totalPayoutMOR)
        let payPerHour = ((totalPay / totalHoursOfLessonsGiven) * 100) / 100
        setAverageTeacherPay(Math.round(payPerHour * 100)/100)
    }

    const generateTotalLessonsGiven = () => {
        let lessonCounter = 0
        let hourCounter = 0
        for(let i = 0; i < timesheets.length; i++) {
            for(let j = 0; j < timesheets[i].families.length; j++) {
                for(let k = 0; k < timesheets[i].families[j].lessons.length; k++) {
                    hourCounter = hourCounter + timesheets[i].families[j].lessons[k].lessonLength
                    lessonCounter++
                }
            }
        }
        setTotalLessonsGiven(lessonCounter)
        setTotalHoursOfLessonsGiven(hourCounter/60)
    }

    const generateAverageLessonsPerMonth = () => {
        let lessonCounter = 0
        let studentCounter = 0
        let studentHash = {}
        for(let i = 0; i < timesheets.length; i++) {
            for(let j = 0; j < timesheets[i].families.length; j++) {
                for(let k = 0; k < timesheets[i].families[j].lessons.length; k++) {
                    let studentName = timesheets[i].families[j].lessons[k].studentName
                    if(studentHash[studentName]) {

                    } else {
                        studentCounter++
                        studentHash[studentName] = true
                    }
                    lessonCounter++
                }
            }
        }
        setStudentsTaught(studentCounter)
        setAverageNumberOfLessonsTaught(Math.round((lessonCounter/studentCounter)*100) / 100)
    }

    const generateTotalBillingAmount = () => {
        for(let j = 0; j < schoolList.length; j++){
            let total = 0
            for(let i = 0; i < invoices.length; i++) {
                if(invoices[i].school === schoolList[j]) {
                    let invoiceWithFamily = invoices[i]
                    //schoolList[j] === 'psma' && console.log(invoices[i])
                    if(invoiceWithFamily.waveCustomerId && invoiceWithFamily.status !== 'Scholarship') {
                        for(let i = 0; i < students.length; i++) {
                            if(invoiceWithFamily.waveCustomerId === students[i].waveCustomerId) {
                                invoiceWithFamily.familyInfo = students[i]
                            }
                        }
                        // let res = await axios.get(`${baseUrl}/family-lookup/${invoiceWithFamily.waveCustomerId}`, myHeader)
                        // invoiceWithFamily.familyInfo = res.data
                        for(let j = 0; j < invoices[i].lessonsToBeBilled.length; j++) {
                            total = Math.floor(parseInt(total) + parseInt(findStudentRate(invoiceWithFamily, invoices[i].lessonsToBeBilled[j], invoices[i].lessonsToBeBilled[j].studentName, invoices[i].lessonsToBeBilled[j].lessonLength)))
                        }
                        for(let j = 0; j < invoices[i].extrasToBeBilled.length; j++) {
                          total = Math.floor(parseInt(total) + parseInt(invoices[i].extrasToBeBilled[j].amount))
                        }
                    }
                }
            }
            if(schoolList[j] === 'mma') {
                setTotalToChargeMMA(total)
            } else if (schoolList[j] === 'lsma') {
                setTotalToChargeLSMA(total)
            } else if (schoolList[j] === 'tma') {
                setTotalToChargeTMA(total)
            } else if (schoolList[j] === 'mor') {
                setTotalToChargeMOR(total)
            } else if (schoolList[j] === 'psma') {
                setTotalToChargePSMA(total)
            } else if (schoolList[j] === 'tem') {
                setTotalToChargeTEM(total)
            }
        }
    }

    const calculateEstimatedPay = (arrayOfSheets) => {
        let total = 0
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < arrayOfSheets.length; i++) {
            let theTimesheet = arrayOfSheets[i]
            for(let i = 0; i < theTimesheet.families.length; i++) {
                let fam = theTimesheet.families[i]
                for(let i = 0; i < fam.lessons.length; i++) {
                    minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
                }
                for(let i = 0; i < fam.cancellations.length; i++) {
                    if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                        minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                    }
                }
                for(let i = 0; i < fam.extras.length; i++) {
                    allExtras = Number(allExtras) + Number(fam.extras[i].amount)
                }
            }
        }
        return `$${((minutesTaught/60) * Number(arrayOfSheets[0].teacherRate)) + allExtras}`
    }

    const calculateEstimatedPayAgain = (theTimesheet) => {
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < theTimesheet.families.length; i++) {
            let fam = theTimesheet.families[i]
            for(let i = 0; i < fam.lessons.length; i++) {
                minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
            }
            for(let i = 0; i < fam.cancellations.length; i++) {
                if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                    minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                }
            }
            for(let i = 0; i < fam.extras.length; i++) {
                allExtras = Number(allExtras) + Number(fam.extras[i].amount)
            }
        }
        return ((minutesTaught/60) * Number(theTimesheet.teacherRate)) + allExtras
    }

    const ifTheyHaveTurnedInTheirTimesheetCalculatePay = (teacherId) => {
        let found = false
        let arrayOfSheets = []
        for(let i = 0; i < timesheets.length; i++) {
            if(timesheets[i].teacherId === teacherId) {
                found = true
                arrayOfSheets.push(timesheets[i])
            }
        }
        if(!found) {
            return '-'
        } else {
            return calculateEstimatedPay(arrayOfSheets)
        }
    }

    const generateTotalPayout = () => {
        for(let j = 0; j < schoolList.length; j++) {
            let totalForSchool = 0
            for(let i = 0; i < timesheets.length; i++) {
                if(timesheets[i].school === schoolList[j]) {
                    totalForSchool = Math.floor(totalForSchool + parseInt(calculateEstimatedPayAgain(timesheets[i])))
                }
            }
            if(schoolList[j] === 'mma') {
                setTotalPayoutMMA(totalForSchool)
            } else if (schoolList[j] === 'lsma') {
                setTotalPayoutLSMA(totalForSchool)
            } else if (schoolList[j] === 'tma') {
                setTotalPayoutTMA(totalForSchool)
            } else if (schoolList[j] === 'mor') {
                setTotalPayoutMOR(totalForSchool)
            } else if (schoolList[j] === 'psma') {
                setTotalPayoutPSMA(totalForSchool)
            } else if (schoolList[j] === 'tem') {
                setTotalPayoutTEM(totalForSchool)
            }
        }
        //-------------------OLD WAY----------------------
        // for(let j = 0; j < schoolList.length; j++) {
        //     let total = 0
        //     for(let i = 0; i < teachers.length; i++) {
        //         if(teachers[i].School === schoolList[j]) {
        //             let teachersPay = ifTheyHaveTurnedInTheirTimesheetCalculatePay(teachers[i].TeacherID)
        //             if(teachersPay !== '-') {
        //                 let teachersPayNumber = teachersPay.substring(1)
        //                 total = Math.floor(parseInt(total + parseInt(teachersPayNumber)))
        //             }
        //         }
        //     }
        //     if(schoolList[j] === 'mma') {
        //         setTotalPayoutMMA(total)
        //     } else if (schoolList[j] === 'lsma') {
        //         setTotalPayoutLSMA(total)
        //     } else if (schoolList[j] === 'tma') {
        //         setTotalPayoutTMA(total)
        //     } else if (schoolList[j] === 'mor') {
        //         setTotalPayoutMOR(total)
        //     }
        // }
    }

    const findStudentRate = (invoice, lesson, nameOnInvoice, lengthOfLesson) => {
        let found = false
        if(parseInt(lengthOfLesson) === 31 || parseInt(lengthOfLesson) === 46 || parseInt(lengthOfLesson) === 61 || parseInt(lengthOfLesson) === 32 || parseInt(lengthOfLesson) === 47 || parseInt(lengthOfLesson) === 62) {
          found = true
          if(parseInt(lengthOfLesson) === 31) {
            return 25
          } else if (parseInt(lengthOfLesson) === 46) {
            return 35
          } else if (parseInt(lengthOfLesson) === 61) {
            return 45
          } else if (parseInt(lengthOfLesson) === 32) {
            return 0
        } else if (parseInt(lengthOfLesson) === 47) {
            return 0
        }
        else if (parseInt(lengthOfLesson) === 62) {
            return 0
        }
        } else {
          if(lesson.studentAllRates) {
            return lesson.studentAllRates[lengthOfLesson]
          } else {
          //-----------THIS IS GOING OFF OF WHAT THE STUDENTS RATE WAS BASED OFF OF REAL TIME DATABASE RATE
            for(let i = 0; i < invoice.familyInfo.students.length; i++) {
              if(invoice.familyInfo.students[i].studentName === nameOnInvoice) {
                  found = true
                  if(!invoice.familyInfo.students[i].allRates) {
                    return invoice.familyInfo.students[i].lessonRate
                  } else {
                    return invoice.familyInfo.students[i].allRates[lengthOfLesson]
                  }
              }
          }
          }
        }
        if(!found) {
            console.log('oooooh no!')
            //alert('Student does not exist in the database. Either change student name or go to Student Database and add student to family.')
            return 0
        }
      }

    const totalRevenue = parseInt(totalToChargeMMA + totalToChargeLSMA + totalToChargeTMA + totalToChargeMOR + totalToChargePSMA + totalToChargeTEM)
    const totalPayout = parseInt(totalPayoutMMA + totalPayoutLSMA + totalPayoutTMA + totalPayoutMOR + totalPayoutPSMA + totalPayoutTEM)
    const estimatedProfit = parseInt(totalRevenue - totalPayout - briPay - courtneyPay)
    const averageLessonLength = totalLessonsGiven > 0 ? Math.round(((totalHoursOfLessonsGiven * 60)/totalLessonsGiven) * 100) /100 : 0
    const schoolSummaryRows = [
        { school: 'MMA', revenue: totalToChargeMMA, payout: totalPayoutMMA },
        { school: 'LSMA', revenue: totalToChargeLSMA, payout: totalPayoutLSMA },
        { school: 'TSMA', revenue: totalToChargeTMA, payout: totalPayoutTMA },
        { school: 'MOR', revenue: totalToChargeMOR, payout: totalPayoutMOR },
        { school: 'PSMA', revenue: totalToChargePSMA, payout: totalPayoutPSMA },
        { school: 'TEM', revenue: totalToChargeTEM, payout: totalPayoutTEM },
    ]


    return(
        <div className="top-billing-box-wrapper">
            <div className='top-billing-box-wrapper__header'>
                <div>
                    <div className='top-billing-box-wrapper__eyebrow'>Owner Summary</div>
                    <div className='top-billing-box-wrapper__title'>Monthly Billing Snapshot</div>
                </div>
                <div className='top-billing-box-wrapper__header-actions'>
                    <button
                        className='top-billing-box-wrapper__toggle'
                        onClick={() => setIsOpen((currentValue) => !currentValue)}
                        type='button'
                    >
                        {isOpen ? 'Hide summary' : 'Show summary'}
                    </button>
                    {isOpen && (
                        <div className='top-billing-box-wrapper__people-costs'>
                            <label className="employee-pay__inputs">
                                <span>Bri</span>
                                <input value={briPay} onChange={(e) => setBriPay(e.target.value)} />
                            </label>
                            <label className="employee-pay__inputs">
                                <span>Courtney</span>
                                <input value={courtneyPay} onChange={(e) => setCourtneyPay(e.target.value)} />
                            </label>
                        </div>
                    )}
                </div>
            </div>

            {isOpen && (
                <>
                    <div className='top-billing-box-wrapper__kpi-grid'>
                        <div className='top-billing-box-wrapper__kpi-card'>
                            <div className='top-billing-box-wrapper__kpi-label'>Revenue</div>
                            <div className='top-billing-box-wrapper__kpi-value'>{currencyFormatter.format(totalRevenue)}</div>
                        </div>
                        <div className='top-billing-box-wrapper__kpi-card'>
                            <div className='top-billing-box-wrapper__kpi-label'>Payout</div>
                            <div className='top-billing-box-wrapper__kpi-value top-billing-box-wrapper__kpi-value--negative'>-{currencyFormatter.format(totalPayout).replace('$', '$')}</div>
                        </div>
                        <div className='top-billing-box-wrapper__kpi-card top-billing-box-wrapper__kpi-card--profit'>
                            <div className='top-billing-box-wrapper__kpi-label'>Estimated Profit</div>
                            <div className='top-billing-box-wrapper__kpi-value'>{currencyFormatter.format(estimatedProfit)}</div>
                        </div>
                    </div>

                    <div className='top-billing-box-wrapper__content-grid'>
                        <div className='top-billing-box-wrapper__section'>
                            <div className='top-billing-box-wrapper__section-title'>Cancellations</div>
                            <div className='top-billing-box-wrapper__cancellation-grid'>
                                <div className="top-billing-each-type-of-cancellation">
                                    <div className="type-of-cancellation-title">Student Cancellations</div>
                                    <div className='top-billing-each-type-of-cancellation__metric'>{studentCancellations}</div>
                                    <div className="amount-of-loss-per-cancellation"><strong className="amount-of-loss-dollars">-{currencyFormatter.format(studentRevenueLoss)}</strong></div>
                                </div>
                                <div className="top-billing-each-type-of-cancellation">
                                    <div className="type-of-cancellation-title">Teacher Cancellations</div>
                                    <div className='top-billing-each-type-of-cancellation__metric'>{teacherCancellations}</div>
                                    <div className="amount-of-loss-per-cancellation"><strong className="amount-of-loss-dollars">-{currencyFormatter.format(teacherRevenueLoss)}</strong></div>
                                </div>
                                <div className="top-billing-each-type-of-cancellation">
                                    <div className="type-of-cancellation-title">Short Notice</div>
                                    <div className='top-billing-each-type-of-cancellation__metric'>{chargedCancellations}</div>
                                    <div className="amount-of-loss-per-cancellation">Charged to family</div>
                                </div>
                            </div>
                        </div>

                        <div className='top-billing-box-wrapper__section'>
                            <div className='top-billing-box-wrapper__section-title'>Teaching Stats</div>
                            <div className='top-billing-box-wrapper__stats-grid'>
                                <div className='top-billing-box-wrapper__stat-chip'><span>Lessons</span><strong>{totalLessonsGiven}</strong></div>
                                <div className='top-billing-box-wrapper__stat-chip'><span>Hours</span><strong>{totalHoursOfLessonsGiven}</strong></div>
                                <div className='top-billing-box-wrapper__stat-chip'><span>Avg Lesson</span><strong>{averageLessonLength} min</strong></div>
                                <div className='top-billing-box-wrapper__stat-chip'><span>Students</span><strong>{studentsTaught}</strong></div>
                                <div className='top-billing-box-wrapper__stat-chip'><span>Lessons / Student</span><strong>{averageNumberOfLessonsTaught}</strong></div>
                                <div className='top-billing-box-wrapper__stat-chip'><span>Avg Lesson Rate</span><strong>{currencyFormatter.format(averageLessonHourlyCost)}</strong></div>
                                <div className='top-billing-box-wrapper__stat-chip'><span>Avg Teacher Rate</span><strong>{currencyFormatter.format(averageTeacherPay)}</strong></div>
                            </div>
                        </div>
                    </div>

                    <div className='top-billing-box-wrapper__section top-billing-box-wrapper__section--schools'>
                        <div className='top-billing-box-wrapper__section-title'>By School</div>
                        <div className='top-billing-box-wrapper__school-table-wrap'>
                            <table className='top-billing-box-wrapper__school-table'>
                                <thead>
                                    <tr>
                                        <th>School</th>
                                        <th>Revenue</th>
                                        <th>Payout</th>
                                        <th>Profit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {schoolSummaryRows.map((row) => (
                                        <tr key={row.school}>
                                            <td>{row.school}</td>
                                            <td>{currencyFormatter.format(row.revenue)}</td>
                                            <td>-{currencyFormatter.format(row.payout).replace('$', '$')}</td>
                                            <td>{currencyFormatter.format(row.revenue - row.payout)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
export default OwnerMonthlyTimesheetOverview;
